/* eslint-disable react/prop-types -- ImgProps typed in TypeScript */
import React from 'react';

import wordmarkPng from '../../../../assets/branding/raceranger-wordmark.png';
import brandIconSvgUrl from '../../../../assets/branding/raceranger-icon.svg';

type ImgProps = React.ImgHTMLAttributes<HTMLImageElement>;

/** Horizontal RaceRanger wordmark (PNG). Intended for dark login/splash backgrounds. */
export function RaceRangerWordmarkImg(props: ImgProps): React.JSX.Element {
  const { className = '', alt = 'RaceRanger', ...rest } = props;
  return (
    <img
      src={wordmarkPng}
      alt={alt}
      draggable={false}
      className={[
        'h-auto max-h-full w-auto max-w-full select-none object-contain object-center',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      // eslint-disable-next-line react/jsx-props-no-spreading -- passthrough native img attrs
      {...rest}
    />
  );
}

/**
 * Colour RR mark (bundled as URL). Webpack emits SVG as asset filenames, not SVGR components.
 */
export function RaceRangerIconMark(props: ImgProps): React.JSX.Element {
  const { className = '', alt = '', ...rest } = props;
  return (
    <img
      src={brandIconSvgUrl}
      alt={alt}
      draggable={false}
      role={alt ? undefined : 'presentation'}
      className={[
        'block h-full w-full shrink-0 select-none object-contain object-center',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      // eslint-disable-next-line react/jsx-props-no-spreading -- passthrough native img attrs
      {...rest}
    />
  );
}
